import { ReactMarkdownOptions } from 'react-markdown/lib/react-markdown';
import { A } from './replacers/A';

export const components: ReactMarkdownOptions['components'] = {
  a: A,
};
